import { ActivitiesContentType } from 'global/constants';
import { ComponentColumns } from '../component.constants';
import {
  COLOUR_BLUE,
  COLOUR_AZURE,
  COLOUR_CYAN,
  COLOUR_GREEN,
  COLOUR_GREY,
  COLOUR_LIME,
  COLOUR_MAGENTA,
  COLOUR_ORANGE,
  COLOUR_PURPLE,
  COLOUR_RED,
  COLOUR_VOLCANO,
  COLOUR_YELLOW,
} from 'approot/shared/colour/colour.constants';

export type ViewProps = Omit<ComponentColumns, '__typename'> & {
  contentId: number;
};
export type EditProps = ViewProps & {
  lessonId: number;
  contentType: ActivitiesContentType;
};
export type PrintProps = Omit<ComponentColumns, '__typename'>;

export const HANDLE_ID_PREFIX = 'handle-';
export const COLUMN_ID_PREFIX = 'column-';

export const COLUMN_COLOURS = [
  COLOUR_GREY,
  COLOUR_MAGENTA,
  COLOUR_RED,
  COLOUR_VOLCANO,
  COLOUR_ORANGE,
  COLOUR_YELLOW,
  COLOUR_LIME,
  COLOUR_GREEN,
  COLOUR_CYAN,
  COLOUR_BLUE,
  COLOUR_AZURE,
  COLOUR_PURPLE,
];
